import {Controller} from "stimulus"
import $ from 'jquery';
import bootbox from 'bootbox/bootbox';
import toastr from 'toastr/toastr'
import 'toastr/toastr.scss'
import 'bootstrap-table/dist/bootstrap-table.min.css'
import 'bootstrap-table/dist/bootstrap-table.min'
import 'bootstrap-table/dist/locale/bootstrap-table-es-ES.min'
import 'bootstrap-table/dist/extensions/custom-view/bootstrap-table-custom-view'
import 'bootstrap-table/dist/extensions/editable/bootstrap-table-editable'
import {obtenerIdCheckDatatable} from "./admin_controller";


export default class extends Controller {

    initialize() {
        let table = $(this.element);
        table.bootstrapTable({
            language: 'es',
            pagination: true,
            sidePagination: 'client',
            search: true,
            pageSize: 10,
            pageList: "[10, 25, 50, 100, 200, All]",
            sortable: true

        });
        setTimeout(()=>{
            if(this.element.dataset.hasOwnProperty('click')){
                table.find(`[data-field="${this.element.dataset.click}"]`).find('div.th-inner').trigger('click');
            }
        },1000)
    }
}